import { render } from "./ExchangeRates.vue?vue&type=template&id=3d4b72f3"
import script from "./ExchangeRates.vue?vue&type=script&lang=js"
export * from "./ExchangeRates.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GitHub\\KirillSuprunJob.github.io\\Portfolio\\AlbumPortfolio\\InfoWebPage\\info_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__